import { callRequest } from '@/client/bridge'

/**
 * @description 获取猎豹浏览器版本
 * @return {string}
 */
export const clientGetLiebaoVersion = (function (window) {
  return window.chrome &&
  window.chrome.LiebaoGetVersion &&
  typeof window.chrome.LiebaoGetVersion === 'function'
    ? function () {
      return window.chrome.LiebaoGetVersion()
    }
    : function () {
      return '0'
    }
}(window))

/**
 * @description 获取客户端渠道号
 * @return{number}
 */
export const clientGetTryNo = (function (window) {
  // eslint-disable-next-line sonarjs/no-all-duplicated-branches
  return window.chrome &&
    window.chrome.GetTryNo &&
    typeof window.chrome.GetTryNo === 'function'
    ? function () {
      return window.chrome.GetTryNo() || 8011
    }
    : function () {
      return 8011
    }
}(window))

/**
 * @description 获取浏览器用户信息
 * @return {Object|null}
 */
export const clientGetUserInfo = function () {
  return callRequest({
    fn: 'user_info'
  })
}

/**
 * @description 登录
 * @return {null}
 */
export const clientLogin = function () {
  callRequest({
    fn: 'login_new'
  })
}

/**
 * @description VIP 弹框
 */
export const clientVipDialog = function () {
  callRequest({
    show_vip_rights: 12
  })
}
